export enum ResponseTypes {
    WARNING = "warning",
    SUCCESS = "success"
}